var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { KtsTaskService } from './task.service';
import { ConstructionTask, ConstructionTaskOtherField, KtsConstructionTaskService } from './construction-task.service';
import { classData, KtsGeneralTaskService, TaskData, TaskTemplate } from './general-task.service';
import { AlertModalService } from '../../../../component/alertmodal/alertmodal.service';
import { ValidationService } from '../../../../service/validation.service';
var KtsGeneralTaskComponent = /** @class */ (function (_super) {
    __extends(KtsGeneralTaskComponent, _super);
    function KtsGeneralTaskComponent(router, route, logger, action, message, page, service, taskService, constTaskService, alertModalService, validService) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.taskService = taskService;
        _this.constTaskService = constTaskService;
        _this.alertModalService = alertModalService;
        _this.validService = validService;
        _this.toggles = {};
        _this.classToggles = {};
        _this.taskToggles = {};
        _this.orgClassToggles = {};
        _this.orgTaskToggles = {};
        _this.items = {};
        _this.taskMItems = [];
        _this.taskUItems = {};
        _this.fieldUItems = {};
        _this.deleteItems = [];
        _this.classSeq = 1;
        _this.taskSeq = 1;
        _this.readonly = false;
        _this.taskMode = "setting" /* setting */;
        _this.fileOptions = {};
        _this.deleteFlg = false;
        _this.classRequiredError = [];
        _this.step = [];
        _this.constClass = [];
        _this.constMiddleClass = {};
        _this.taskType = [];
        _this.inspection = [];
        _this.referrerType = [];
        _this.partner = [];
        _this.secondaryPartner = [];
        _this.genre = [];
        _this.reportStatus = [];
        _this.dispTask = false;
        return _this;
    }
    KtsGeneralTaskComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.taskMode = jsonpath.value(this.component, '$.params.taskMode') || "setting" /* setting */;
        this.fileOptions = jsonpath.value(this.component, '$.params.fileOptions') || {};
        this.taskTemplate = new TaskTemplate(this.msgSnapshot, this.readonly, this.taskMode, this.fileOptions);
        for (var step = 1; step <= 5; step++) {
            this.items[step] = [];
        }
        this.getType();
    };
    KtsGeneralTaskComponent.prototype.switchToggle = function (step) {
        this.toggles[step] = !this.toggles[step];
    };
    KtsGeneralTaskComponent.prototype.switchClassToggle = function (seq) {
        this.classToggles[seq] = !this.classToggles[seq];
        this.orgClassToggles[seq] = this.classToggles[seq];
    };
    KtsGeneralTaskComponent.prototype.switchTaskToggle = function (seq) {
        this.taskToggles[seq] = !this.taskToggles[seq];
        this.orgTaskToggles[seq] = this.taskToggles[seq];
    };
    KtsGeneralTaskComponent.prototype.getType = function () {
        var _this = this;
        this.DATE_DELIMITER_SLASH = moment().toMomentFormatString(this.msgSnapshot['au.COMPONENT.DateTimeComponent.option.formatDate']);
        this.DATETIME_DELIMITER_SLASH = moment().toMomentFormatString(this.msgSnapshot['au.COMPONENT.DateTimeComponent.option.format']);
        this.service.getType('CONSTRUCTION_STEP').subscribe(function (rec) { return _this.step = rec; });
        this.service.setBaseUrl('/v1/gen/construction-classification-m-api?query={"orderByList":[{"name":"id","direction":"asc"}]}');
        this.service.getRecord().subscribe(function (rec) {
            var constClass = [];
            var constMiddleClass = {};
            constClass.push({
                code: '',
                display: _this.msgSnapshot['au.COMPONENT.KtsConstructionClassificationComponent.select.classification']
            });
            constMiddleClass[''] = [{
                    code: '',
                    display: _this.msgSnapshot['au.COMPONENT.KtsConstructionClassificationComponent.select.middle_classification']
                }];
            for (var _i = 0, _a = rec.items; _i < _a.length; _i++) {
                var item = _a[_i];
                constClass.push({ code: item.id, display: item.name });
                var options = [];
                _this.constTaskService.sortItems(item.construction_middle_classification, 'id');
                for (var _b = 0, _c = item.construction_middle_classification; _b < _c.length; _b++) {
                    var middleItem = _c[_b];
                    options.push({ code: middleItem.id, display: middleItem.name });
                }
                constMiddleClass[item.id] = [{
                        code: '',
                        display: _this.msgSnapshot['au.COMPONENT.KtsConstructionClassificationComponent.select.middle_classification']
                    }].concat(options);
            }
            _this.constClass = constClass;
            _this.constMiddleClass = constMiddleClass;
            // 工種分類の取得がonSubscribe()より遅かった場合
            if (_this.taskMItems.length > 0) {
                for (var step = 1; step <= 5; step++) {
                    for (var _d = 0, _e = _this.items[step]; _d < _e.length; _d++) {
                        var classData_1 = _e[_d];
                        var className = _this.getClassificationName(null, classData_1.task[0].task_u.construction_middle_classification_id);
                        classData_1.construction_classification_id = className.classId;
                        classData_1.construction_classification_name = className.className;
                        classData_1.construction_middle_classification_id = className.middleClassId;
                        classData_1.construction_middle_classification_name = className.middleClassName;
                    }
                }
            }
        });
        this.service.getType('TASK_TEMPLATE_TYPE').subscribe(function (rec) {
            var option = [];
            var inspection = [];
            for (var _i = 0, rec_1 = rec; _i < rec_1.length; _i++) {
                var r = rec_1[_i];
                if (r.code === 'inspection') {
                    inspection.push(r);
                }
                else {
                    option.push(r);
                }
            }
            _this.taskType = option;
            _this.inspection = inspection;
        });
        this.service.getType('REFERRER_TYPE').subscribe(function (rec) {
            _this.referrerType = rec;
            _this.taskTemplate.upload[2].params.options = _this.referrerType;
        });
        this.constTaskService.getGenre().subscribe(function (rec) {
            _this.genre = rec;
            _this.taskTemplate.upload[0].params.options = _this.genre;
        });
        this.service.getType('CONSTRUCTION_REPORT_STATUS').subscribe(function (rec) {
            _this.reportStatus = rec;
            _this.taskTemplate.datetime[0].items[1].params.options = _this.reportStatus;
            _this.taskTemplate.date[0].items[1].params.options = _this.reportStatus;
        });
    };
    KtsGeneralTaskComponent.prototype.onMsg = function (msg) {
        this.taskTemplate = new TaskTemplate(msg, this.readonly, this.taskMode, this.fileOptions);
    };
    KtsGeneralTaskComponent.prototype.setUnsubscribe = function () {
        this.changeSubscription.unsubscribe();
    };
    KtsGeneralTaskComponent.prototype.onSubscribe = function (data) {
        var _this = this;
        if (typeof data.project_m_id !== 'undefined') {
            this.projectMId = data.project_m_id;
            this.constTaskService.getPartnerCompany(data.project_m_id).subscribe(function (rec) {
                _this.taskTemplate.onsite.cols[0].params.options = rec;
                _this.taskTemplate.onsite_notime.cols[0].params.options = rec;
                _this.taskTemplate.construction.cols[0].params.options = rec;
                _this.taskTemplate.onsite.cols[1].params.options = rec;
                _this.taskTemplate.onsite_notime.cols[1].params.options = rec;
                _this.taskTemplate.construction.cols[1].params.options = rec;
                _this.partner = rec;
                _this.secondaryPartner = rec;
            });
        }
        if (typeof data.construction_m_id !== 'undefined') {
            this.constructionMId = data.construction_m_id;
            this.taskUItems = {};
            this.fieldUItems = {};
            return;
        }
        if (typeof data.items === 'undefined' || !(data.items instanceof Array) || data.items.length === 0) {
            return;
        }
        data = JSOG.parse(JSON.stringify(data));
        // task_u
        if (typeof data.items[0].task_m_id !== 'undefined' && typeof data.items[0].is_complete !== 'undefined') {
            this.setTaskU(data.items);
            this.setItems();
        }
        // task_other_field_u
        if (typeof data.items[0].task_other_field_m_id !== 'undefined') {
            this.setFieldU(data.items);
            this.setItems();
        }
        // task_m
        if (typeof data.items[0].project_m_id !== 'undefined' && typeof data.items[0].template_type !== 'undefined') {
            this.taskMItems = data.items;
            this.setItems();
        }
    };
    KtsGeneralTaskComponent.prototype.setTaskU = function (items) {
        var taskUItems = {};
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (!item.construction_middle_classification_id) {
                continue;
            }
            if (item.construction_report && item.construction_report.length > 0) {
                this.constTaskService.sortDatetime(item.construction_report);
            }
            if (item.construction_documents && item.construction_documents.length > 0) {
                this.constTaskService.sortItems(item.construction_documents, 'id');
                item.documents_genre_id = item.documents_genre_id;
                item.documents_title = item.construction_documents[0].title;
                item.documents_type = item.construction_documents[0].type;
            }
            item.$type = "put" /* Put */;
            taskUItems[item.task_m_id] = item;
        }
        this.taskUItems = taskUItems;
    };
    KtsGeneralTaskComponent.prototype.setFieldU = function (items) {
        var fieldUItems = {};
        for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
            var item = items_2[_i];
            item.$type = "put" /* Put */;
            fieldUItems[item.task_other_field_m_id] = item;
        }
        this.fieldUItems = fieldUItems;
    };
    KtsGeneralTaskComponent.prototype.setItems = function () {
        if (this.taskMItems.length === 0) {
            return;
        }
        var items = {};
        this.deleteItems = [];
        this.deleteFlg = false;
        this.taskService.resetFieldComp();
        this.constTaskService.resetVisitComp();
        this.classSeq = 1;
        this.taskSeq = 1;
        for (var step = 1; step <= 5; step++) {
            items[step] = [];
        }
        for (var _i = 0, _a = this.taskMItems; _i < _a.length; _i++) {
            var taskM = _a[_i];
            var taskU = this.taskUItems[taskM.id];
            var classIndex = -1;
            if (typeof taskU === 'undefined') {
                continue;
            }
            for (var i = 0; i < items[taskM.step].length; i++) {
                if (items[taskM.step][i].construction_middle_classification_id.toString() === taskU.construction_middle_classification_id.toString()) {
                    classIndex = i;
                    break;
                }
            }
            if (classIndex === -1) {
                var className = this.getClassificationName(null, taskU.construction_middle_classification_id);
                items[taskM.step].push({
                    $seq: this.classSeq++,
                    construction_classification_id: className.classId,
                    construction_classification_name: className.className,
                    construction_middle_classification_id: className.middleClassId,
                    construction_middle_classification_name: className.middleClassName,
                    task: []
                });
                classIndex = items[taskM.step].length - 1;
            }
            if (taskM.task_other_field_m && taskM.task_other_field_m.length > 0) {
                this.constTaskService.sortItems(taskM.task_other_field_m);
            }
            for (var _b = 0, _c = taskM.task_other_field_m; _b < _c.length; _b++) {
                var fieldM = _c[_b];
                fieldM['$type'] = "put" /* Put */;
                fieldM['value'] = null;
                if (typeof this.fieldUItems[fieldM.id] !== 'undefined') {
                    fieldM['value'] = this.fieldUItems[fieldM.id].value;
                }
            }
            if (taskM.template_type === "onsite_notime" /* onsite_notime */) {
                for (var _d = 0, _e = taskU.construction_report; _d < _e.length; _d++) {
                    var report = _e[_d];
                    var dateKeys = ['visiting_scheduled_date', 'leaving_scheduled_date'];
                    for (var _f = 0, dateKeys_1 = dateKeys; _f < dateKeys_1.length; _f++) {
                        var key = dateKeys_1[_f];
                        if (report[key]) {
                            report[key] = moment(report[key], this.DATETIME_DELIMITER_SLASH).format(this.DATE_DELIMITER_SLASH);
                        }
                    }
                }
            }
            taskM.$type = "put" /* Put */;
            items[taskM.step][classIndex].task.push({
                $seq: this.taskSeq++,
                task_name: taskM.name,
                task_m: taskM,
                task_u: taskU,
                construction_documents: taskU.construction_documents,
                construction_documents_delete: [],
                task_other_field_m: taskM.task_other_field_m
            });
        }
        this.items = items;
        this.classToggles = Object.assign({}, this.orgClassToggles);
        this.taskToggles = Object.assign({}, this.orgTaskToggles);
    };
    KtsGeneralTaskComponent.prototype.onModeSubscribe = function (mode) {
        this.readonly = false;
        if (mode === 'confirm') {
            this.readonly = true;
        }
    };
    KtsGeneralTaskComponent.prototype.onEventSubscribe = function (e) {
        if (e === 'languageChange') {
            this.getType();
        }
        else if (e === this.componentName + '#dispTask') {
            this.dispTask = true;
        }
        else if (e === this.componentName + '#button') {
            this.setCompRec();
            // 必須チェック
            var event_1 = this.action.getEvent('taskSave');
            if (typeof event_1.action === 'undefined') {
                return;
            }
            var valid = this.validService.validation('submit', event_1, this.action.getCompRec(), this.msgSnapshot);
            this.classRequiredError = this.service.getClassSeq();
            if (!valid.validation) {
                return;
            }
            // 確認のアラートモーダルを表示
            var msg = this.deleteFlg ? this.msgSnapshot['au.COMPONENT.KtsGeneralTaskComponent.Modal.save.confirmIncludingDelete'] : this.msgSnapshot['au.COMPONENT.KtsGeneralTaskComponent.Modal.save.confirm'];
            this.alertModalService.open({
                message: msg,
                buttons: [{
                        class: 'ok',
                        event: this.componentName + '#save#ok',
                        caption: this.msgSnapshot['Modal.button.ok']
                    }, {
                        class: 'cancel',
                        event: this.componentName + '#save#cancel',
                        caption: this.msgSnapshot['Modal.button.cancel']
                    }]
            });
        }
        else if (e === this.componentName + '#save#ok') {
            // タスク保存
            this.action.firstAction('taskSave');
        }
    };
    KtsGeneralTaskComponent.prototype.onEvent = function (e1, e2, r) {
        if (e2 === 'addClass') {
            this.switchClassToggle(this.classSeq);
            this.switchTaskToggle(this.taskSeq);
            this.items[r.step].splice(r.classIndex + 1, 0, Object.assign(new classData(), { $seq: this.classSeq++ }));
            this.items[r.step][r.classIndex + 1].task.splice(0, 0, Object.assign(new TaskData(), {
                $seq: this.taskSeq++,
                task_name: this.msgSnapshot['au.COMPONENT.KtsGeneralTaskComponent.label.taskNameNotEntered']
            }));
        }
        else if (e2 === 'deleteClass') {
            for (var _i = 0, _a = this.items[r.step][r.classIndex].task; _i < _a.length; _i++) {
                var taskData = _a[_i];
                this.deleteTask(taskData);
            }
            this.items[r.step].splice(r.classIndex, 1);
        }
        else if (e2 === 'upClass') {
            this.items[r.step].splice(r.classIndex - 1, 2, this.items[r.step][r.classIndex], this.items[r.step][r.classIndex - 1]);
        }
        else if (e2 === 'downClass') {
            this.items[r.step].splice(r.classIndex, 2, this.items[r.step][r.classIndex + 1], this.items[r.step][r.classIndex]);
        }
        else if (e2 === 'addTask') {
            this.switchTaskToggle(this.taskSeq);
            this.items[r.step][r.classIndex].task.splice(r.taskIndex + 1, 0, Object.assign(new TaskData(), {
                $seq: this.taskSeq++,
                task_name: this.msgSnapshot['au.COMPONENT.KtsGeneralTaskComponent.label.taskNameNotEntered']
            }));
            var idx = this.classRequiredError.indexOf(this.items[r.step][r.classIndex].$seq);
            if (idx >= 0) {
                this.classRequiredError.splice(idx, 1);
            }
        }
        else if (e2 === 'deleteTask') {
            this.deleteTask(this.items[r.step][r.classIndex].task[r.taskIndex]);
            this.items[r.step][r.classIndex].task.splice(r.taskIndex, 1);
        }
        else if (e2 === 'upTask') {
            this.items[r.step][r.classIndex].task.splice(r.taskIndex - 1, 2, this.items[r.step][r.classIndex].task[r.taskIndex], this.items[r.step][r.classIndex].task[r.taskIndex - 1]);
        }
        else if (e2 === 'downTask') {
            this.items[r.step][r.classIndex].task.splice(r.taskIndex, 2, this.items[r.step][r.classIndex].task[r.taskIndex + 1], this.items[r.step][r.classIndex].task[r.taskIndex]);
        }
    };
    KtsGeneralTaskComponent.prototype.deleteTask = function (taskData) {
        if (typeof taskData.task_m.id === 'undefined' || taskData.task_m.id === null) {
            return;
        }
        taskData.task_m.$type = "delete" /* Delete */;
        taskData.task_u.$type = "delete" /* Delete */;
        taskData.task_other_field_m.map(function (x) { return x['$type'] = "delete" /* Delete */; });
        this.deleteItems.push(taskData);
        this.deleteFlg = true;
    };
    KtsGeneralTaskComponent.prototype.onChangeClass = function (e, r) {
        this.items[r.step][r.classIndex][e.key] = e.val;
        if (e.key === 'construction_classification_id') {
            this.items[r.step][r.classIndex].construction_middle_classification_id = '';
        }
        var className = this.getClassificationName(this.items[r.step][r.classIndex].construction_classification_id, this.items[r.step][r.classIndex].construction_middle_classification_id);
        this.items[r.step][r.classIndex].construction_classification_name = className.className;
        this.items[r.step][r.classIndex].construction_middle_classification_name = className.middleClassName;
    };
    KtsGeneralTaskComponent.prototype.getClassificationName = function (classId, middleClassId) {
        var className = this.msgSnapshot['au.COMPONENT.KtsGeneralTaskComponent.label.classificationUnselected'];
        var middleClassName = this.msgSnapshot['au.COMPONENT.KtsGeneralTaskComponent.label.middleClassificationUnselected'];
        if (classId || middleClassId) {
            constMiddleClassLoop: for (var _i = 0, _a = Object.keys(this.constMiddleClass); _i < _a.length; _i++) {
                var key = _a[_i];
                for (var _b = 0, _c = this.constMiddleClass[key]; _b < _c.length; _b++) {
                    var option_1 = _c[_b];
                    if (option_1.code && option_1.code.toString() === middleClassId.toString()) {
                        middleClassName = option_1.display;
                        classId = classId ? classId : key;
                        break constMiddleClassLoop;
                    }
                }
            }
            var option = jsonpath.value(this.constClass, '$..[?(@.code=="' + classId + '")]');
            if (typeof option !== 'undefined' && option.code !== '') {
                className = option.display;
            }
        }
        return { classId: classId, className: className, middleClassId: middleClassId, middleClassName: middleClassName };
    };
    KtsGeneralTaskComponent.prototype.onChangeTaskM = function (e, r) {
        this.items[r.step][r.classIndex].task[r.taskIndex].task_m[e.key] = e.val;
        if (e.key === 'template_type') {
            for (var _i = 0, _a = this.items[r.step][r.classIndex].task[r.taskIndex].construction_documents; _i < _a.length; _i++) {
                var documents = _a[_i];
                documents['$type'] = "delete" /* Delete */;
            }
            this.items[r.step][r.classIndex].task[r.taskIndex].construction_documents_delete = this.items[r.step][r.classIndex].task[r.taskIndex].construction_documents.concat(this.items[r.step][r.classIndex].task[r.taskIndex].construction_documents_delete);
            this.items[r.step][r.classIndex].task[r.taskIndex].construction_documents = [];
            var taskU = this.items[r.step][r.classIndex].task[r.taskIndex].task_u;
            this.items[r.step][r.classIndex].task[r.taskIndex].task_u = Object.assign(new ConstructionTask(), {
                $type: taskU.$type,
                id: taskU.id,
                task_m_id: taskU.task_m_id,
                construction_middle_classification_id: taskU.construction_middle_classification_id,
                plan_date: null,
                is_complete: taskU.is_complete
            });
            if (typeof taskU.id !== 'undefined' && taskU.id !== null) {
                this.deleteFlg = true;
            }
        }
        else if (e.key === 'name') {
            this.items[r.step][r.classIndex].task[r.taskIndex].task_name = (e.val === '' ? '(タスク名未入力)' : e.val);
        }
    };
    KtsGeneralTaskComponent.prototype.onChangeTaskU = function (e, r) {
        this.items[r.step][r.classIndex].task[r.taskIndex].task_u[e.key] = e.val;
        if (typeof e.delFlg !== 'undefined' && e.delFlg === true) {
            this.deleteFlg = true;
        }
    };
    KtsGeneralTaskComponent.prototype.onChangeMultiFile = function (e, r) {
        this.items[r.step][r.classIndex].task[r.taskIndex].construction_documents = e['construction_documents'];
    };
    KtsGeneralTaskComponent.prototype.onChangeField = function (e, r) {
        this.items[r.step][r.classIndex].task[r.taskIndex].task_other_field_m = e['task_other_field_m'];
    };
    KtsGeneralTaskComponent.prototype.setCompRec = function () {
        this.service.resetClassSeq();
        var RequestData = [];
        var items = JSOG.parse(JSON.stringify(this.items));
        var deleteItems = JSOG.parse(JSON.stringify(this.deleteItems));
        var classSeq = 1;
        var taskSeq = 1;
        this.orgClassToggles = {};
        this.orgTaskToggles = {};
        for (var step = 1; step <= 5; step++) {
            var order = 1;
            for (var _i = 0, _a = items[step]; _i < _a.length; _i++) {
                var classData_2 = _a[_i];
                for (var _b = 0, _c = classData_2.task; _b < _c.length; _b++) {
                    var taskData = _c[_b];
                    this.orgTaskToggles[taskSeq++] = this.taskToggles[taskData.$seq];
                    RequestData.push(this.getRequestData(step, order++, classData_2.construction_middle_classification_id, taskData));
                }
                if (classData_2.task.length === 0) {
                    this.service.setClassSeq(classData_2.$seq);
                }
                this.orgClassToggles[classSeq++] = this.classToggles[classData_2.$seq];
            }
        }
        for (var _d = 0, deleteItems_1 = deleteItems; _d < deleteItems_1.length; _d++) {
            var deleteItem = deleteItems_1[_d];
            RequestData.push(this.getRequestData(deleteItem.task_m.step, deleteItem.task_m.disp_order, deleteItem.task_u.construction_middle_classification_id, deleteItem));
        }
        this.action.setCompRec(this.componentName, { items: RequestData });
    };
    KtsGeneralTaskComponent.prototype.getRequestData = function (step, order, middleClassId, taskData) {
        // task_m
        var taskM = taskData.task_m;
        taskM.project_m_id = this.projectMId;
        taskM.step = step;
        taskM.disp_order = order;
        var delCols = ['$seq', '$editable', 'task_other_field_m', 'cdate', 'cby', 'udate', 'uby', 'base_status'];
        for (var _i = 0, delCols_1 = delCols; _i < delCols_1.length; _i++) {
            var d = delCols_1[_i];
            if (typeof taskM !== 'undefined') {
                delete taskM[d];
            }
        }
        // task_u, construction_documents
        var taskU = taskData.task_u;
        var documents = taskData.construction_documents.concat(taskData.construction_documents_delete);
        var necessity = (taskU.necessity.toString() === 'false' ? false : true);
        taskU.construction_m_id = this.constructionMId;
        if (typeof middleClassId === 'number') {
            taskU.construction_middle_classification_id = middleClassId;
        }
        else if (typeof middleClassId === 'string' && middleClassId !== '') {
            taskU.construction_middle_classification_id = parseInt(middleClassId);
        }
        for (var i = documents.length - 1; i >= 0; i--) {
            var doc = documents[i];
            if (taskM.template_type !== "file" /* file */ || !necessity || taskM.$type === "delete" /* Delete */) {
                if (typeof doc.id !== 'undefined') {
                    doc['$type'] = "delete" /* Delete */;
                }
                else {
                    documents.splice(i, 1);
                    continue;
                }
            }
            else {
                doc.construction_m_id = this.constructionMId;
                doc.task_u_id = taskU.id;
                doc.documents_genre_id = taskU.documents_genre_id;
                doc.title = taskU.documents_title;
                doc.type = taskU.documents_type;
            }
        }
        delete taskU.construction_documents;
        if (taskM.template_type !== "onsite" /* onsite */ && taskM.template_type !== "onsite_notime" /* onsite_notime */ && taskM.template_type !== "construction" /* construction */) {
            taskU.construction_report = [];
            taskU.partner_company_m_id = null;
            taskU.secondary_partner_company_m_id = null;
        }
        else {
            for (var _a = 0, _b = taskU.construction_report; _a < _b.length; _a++) {
                var report = _b[_a];
                if (report.status === '') {
                    report.status = null;
                }
                if (taskM.template_type === "onsite_notime" /* onsite_notime */) {
                    var dateKeys = ['visiting_scheduled_date', 'leaving_scheduled_date'];
                    for (var _c = 0, dateKeys_2 = dateKeys; _c < dateKeys_2.length; _c++) {
                        var key = dateKeys_2[_c];
                        if (report[key]) {
                            report[key] = moment(report[key], this.DATE_DELIMITER_SLASH).format(this.DATETIME_DELIMITER_SLASH);
                        }
                    }
                }
            }
        }
        // task_other_field_m, task_other_field_u
        var fields = [];
        for (var i = 0; i < taskData.task_other_field_m.length; i++) {
            var fieldM = taskData.task_other_field_m[i];
            var fieldU = new ConstructionTaskOtherField();
            if (typeof taskM.id !== 'undefined') {
                fieldM.task_m_id = taskM.id;
            }
            if (fieldM['$type'] !== "delete" /* Delete */) {
                fieldM.disp_order = i + 1;
                fieldM.name = this.msgSnapshot['au.COMPONENT.KtsGeneralTaskComponent.label.remarks'] + fieldM.disp_order;
            }
            else {
                this.deleteFlg = true;
            }
            fieldU.construction_m_id = this.constructionMId;
            fieldU.value = fieldM['value'];
            if (typeof this.fieldUItems[fieldM.id] !== 'undefined') {
                fieldU.id = this.fieldUItems[fieldM.id].id;
                fieldU.$type = fieldM['$type'];
            }
            else {
                fieldU.$type = "post" /* Post */;
            }
            if (typeof fieldM.id !== 'undefined') {
                fieldU.task_other_field_m_id = fieldM.id;
            }
            if (!fieldU.value) {
                if (typeof fieldU.id === 'undefined') {
                    fieldU = null;
                }
                else {
                    fieldU.$type = "delete" /* Delete */;
                }
            }
            if (typeof fieldM['value'] !== 'undefined') {
                delete fieldM['value'];
            }
            fields.push({ task_other_field_m: fieldM, task_other_field_u: fieldU });
        }
        return { task_m: taskM, task_u: taskU, construction_documents: documents, fields: fields };
    };
    KtsGeneralTaskComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-general-task',
                    template: "<div *ngIf=\"!dispTask\" class=\"row\" id=\"{{ componentName + 'DispTask' }}\">\n  <div class=\"col-sm-12\">\n    <btn [componentName]=\"componentName + '#dispTask'\"\n         [component]=\"{\n           params: {\n             buttons: [{\n               type: 'button',\n               event: componentName + '#dispTask',\n               caption: (msg | async)['au.COMPONENTS.button.task_display']\n             }]\n           }\n         }\"></btn>\n  </div>\n</div>\n<form *ngIf=\"dispTask\" id=\"{{ componentName }}\">\n  <div *ngFor=\"let st of step; let stepIndex = index;\" class=\"row\" [class.-mb-1]=\"stepIndex < step.length - 1\">\n    <div class=\"col-sm-12\">\n      <div class=\"filter\">\n        <p class=\"filter_trigger\">\n          <span [class.open]=\"toggles[st.code]\" (click)=\"switchToggle(st.code)\">STEP{{ st.code }}: {{ st.display }}</span>\n        </p>\n        <div class=\"-mb-1\" [ngClass]=\"taskMode === 'setting' ? '-ml-4' : '-ml-2'\" [style.display]=\"toggles[st.code] ? 'block': 'none'\">\n          <div *ngFor=\"let classItem of items[st.code]; let classIndex = index;\" class=\"filter -my-1\">\n            <ul *ngIf=\"taskMode === 'setting'\" class=\"stageFlow_arrows\">\n              <li *ngIf=\"classIndex > 0\"><a href=\"javascript:void(0);\" class=\"stageFlow_arrows_up\" style=\"top: -15px; left: -35px;\" (click)=\"onEvent($event, 'upClass', {step: st.code, classIndex: classIndex})\"></a></li>\n              <li *ngIf=\"classIndex < items[st.code].length - 1\"><a href=\"javascript:void(0);\" class=\"stageFlow_arrows_down\" style=\"bottom: -40px; left: -35px;\" (click)=\"onEvent($event, 'downClass', {step: st.code, classIndex: classIndex})\"></a></li>\n            </ul>\n            <p class=\"filter_trigger -mb-1\">\n              <span [class.open]=\"classToggles[classItem.$seq]\" (click)=\"switchClassToggle(classItem.$seq)\">{{ classItem.construction_classification_name }} / {{ classItem.construction_middle_classification_name }}</span>\n            </p>\n            <div class=\"-m-1 -mb-1\" [style.display]=\"classToggles[classItem.$seq] ? 'block': 'none'\">\n              <ul class=\"form form-campaign\">\n                <li class=\"stageFlowPane\">\n                  <div class=\"stageFlowPane_border\">\n                    <p *ngIf=\"taskMode === 'setting'\"><a class=\"deleteBtn\" href=\"javascript:void(0);\" (click)=\"onEvent($event, 'deleteClass', {step: st.code, classIndex: classIndex})\"></a></p>\n                    <div class=\"stageFlowPane_border2\">\n                      <column [key]=\"'forminline'\" [componentName]=\"componentName\" [index]=\"classItem.$seq\" [col]=\"{\n                        required: true,\n                        readonly: (taskMode === 'setting' ? readonly : true),\n                        items: [{\n                          key: 'construction_classification_id',\n                          controlType: 'select',\n                          params: {options: constClass}\n                        }, {\n                          key: 'construction_middle_classification_id',\n                          controlType: 'select',\n                          params: {options: constMiddleClass[classItem.construction_classification_id]}\n                        }]\n                      }\" [val]=\"classItem\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChangeClass($event, {step: st.code, classIndex: classIndex})\"></column>\n                    </div>\n                    <div [ngClass]=\"taskMode === 'setting' ? '-ml-4' : '-ml-2'\">\n                      <p *ngIf=\"classRequiredError.indexOf(classItem.$seq) >= 0\" class=\"formError\">{{ (msg | async)['ColumnComponent.error.required'] }}</p>\n                      <div *ngFor=\"let taskItem of classItem.task; let taskIndex = index;\" class=\"filter -my-1\">\n                        <ul *ngIf=\"taskMode === 'setting'\" class=\"stageFlow_arrows\">\n                          <li *ngIf=\"taskIndex > 0\"><a href=\"javascript:void(0);\" class=\"stageFlow_arrows_up\" style=\"top: -15px; left: -35px;\" (click)=\"onEvent($event, 'upTask', {step: st.code, classIndex: classIndex, taskIndex: taskIndex})\"></a></li>\n                          <li *ngIf=\"taskIndex < classItem.task.length - 1\"><a href=\"javascript:void(0);\" class=\"stageFlow_arrows_down\" style=\"bottom: -40px; left: -35px;\" (click)=\"onEvent($event, 'downTask', {step: st.code, classIndex: classIndex, taskIndex: taskIndex})\"></a></li>\n                        </ul>\n                        <p class=\"filter_trigger -mb-1\">\n                          <span [class.open]=\"taskToggles[taskItem.$seq]\" (click)=\"switchTaskToggle(taskItem.$seq)\"><!--\n                            --><span *ngIf=\"taskItem.task_u.is_complete\" style=\"color: #2db2e6; font-weight: 800;\">{{ (msg | async)['au.COMPONENTS.label.task_completion'] }}</span><!--\n                            --><span *ngIf=\"!taskItem.task_u.is_complete\" style=\"color: red; font-weight: 800;\">{{ (msg | async)['au.COMPONENTS.label.task_incomplete'] }}</span><!--\n                            -->: {{ taskItem.task_name }}\n                          </span>\n                        </p>\n                        <div class=\"filter_property_toggle -m-1 -mb-1\" [style.display]=\"taskToggles[taskItem.$seq] ? 'block': 'none'\">\n                          <ul class=\"form form-campaign\">\n                            <li class=\"stageFlowPane\">\n                              <div class=\"stageFlowPane_border\">\n                                <p *ngIf=\"taskMode === 'setting'\"><a class=\"deleteBtn\" href=\"javascript:void(0);\" (click)=\"onEvent($event, 'deleteTask', {step: st.code, classIndex: classIndex, taskIndex: taskIndex})\"></a></p>\n                                <div class=\"stageFlowPane_border2\">\n                                  <column [key]=\"'forminline'\" [componentName]=\"componentName\" [index]=\"taskItem.$seq\" [col]=\"{\n                                    key: 'template_type',\n                                    controlType: 'select',\n                                    required: true,\n                                    readonly: (taskMode === 'setting' ? readonly : true),\n                                    params: {options: taskType}\n                                  }\" [val]=\"taskItem.task_m\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChangeTaskM($event, {step: st.code, classIndex: classIndex, taskIndex: taskIndex})\"></column>\n                                </div>\n                                <p class=\"-mx-1\">{{ taskTemplate[taskItem.task_m.template_type]?.note1 }}</p>\n                                <p *ngIf=\"taskMode === 'setting'\" class=\"-mx-1\">{{ taskTemplate[taskItem.task_m.template_type]?.note2 }}</p>\n                                <div class=\"row -m-1 -mt-1\">\n                                  <div class=\"col-sm-12\">\n                                    <column [key]=\"'form'\" [componentName]=\"componentName\" [index]=\"taskItem.$seq\" [col]=\"taskTemplate.name\" [val]=\"taskItem.task_m\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChangeTaskM($event, {step: st.code, classIndex: classIndex, taskIndex: taskIndex})\"></column>\n                                  </div>\n                                </div>\n                                <div *ngIf=\"taskTemplate[taskItem.task_m.template_type]?.necessity\" class=\"row -m-1 -mt-1\">\n                                  <div class=\"col-sm-12\">\n                                    <column [key]=\"'form'\" [componentName]=\"componentName\" [index]=\"taskItem.$seq\" [col]=\"taskTemplate.necessity\" [val]=\"taskItem.task_u\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChangeTaskU($event, {step: st.code, classIndex: classIndex, taskIndex: taskIndex})\"></column>\n                                  </div>\n                                </div>\n                                <div *ngIf=\"taskTemplate[taskItem.task_m.template_type]?.datetime\" class=\"row -m-1 -mt-1\">\n                                  <div class=\"col-sm-12\">\n                                    <kts-construction-task-visit\n                                        *ngIf=\"reportStatus.length > 0\"\n                                        [componentName]=\"componentName + '#datetime' + taskItem.$seq\"\n                                        [component]=\"{name: componentName + '#datetime' + taskItem.$seq, params: {primaryKey: 'id'}}\"\n                                        [visitCols]=\"taskTemplate.datetime\"\n                                        [vals]=\"taskItem.task_u\"\n                                        (changeField)=\"onChangeTaskU($event, {step: st.code, classIndex: classIndex, taskIndex: taskIndex})\"></kts-construction-task-visit>\n                                  </div>\n                                </div>\n                                <div *ngIf=\"taskTemplate[taskItem.task_m.template_type]?.date\" class=\"row -m-1 -mt-1\">\n                                  <div class=\"col-sm-12\">\n                                    <kts-construction-task-visit\n                                        *ngIf=\"reportStatus.length > 0\"\n                                        [componentName]=\"componentName + '#date' + taskItem.$seq\"\n                                        [component]=\"{name: componentName + '#date' + taskItem.$seq, params: {primaryKey: 'id'}}\"\n                                        [visitCols]=\"taskTemplate.date\"\n                                        [vals]=\"taskItem.task_u\"\n                                        (changeField)=\"onChangeTaskU($event, {step: st.code, classIndex: classIndex, taskIndex: taskIndex})\"></kts-construction-task-visit>\n                                  </div>\n                                </div>\n                                <div *ngFor=\"let col of taskTemplate[taskItem.task_m.template_type]?.cols;\" class=\"row -m-1 -mt-1\">\n                                  <div class=\"col-sm-12\">\n                                    <column *ngIf=\"partner.length > 0\" [key]=\"'form'\" [componentName]=\"componentName\" [index]=\"taskItem.$seq\" [col]=\"col\" [val]=\"taskItem.task_u\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChangeTaskU($event, {step: st.code, classIndex: classIndex, taskIndex: taskIndex})\"></column>\n                                  </div>\n                                </div>\n                                <ng-template [ngIf]=\"taskTemplate[taskItem.task_m.template_type]?.upload\">\n                                  <div *ngFor=\"let col of taskTemplate.upload\" class=\"row -m-1 -mt-1\">\n                                    <div class=\"col-sm-12\">\n                                      <column [key]=\"'form'\" [componentName]=\"componentName\" [index]=\"taskItem.$seq\" [col]=\"col\" [val]=\"taskItem.task_u\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChangeTaskU($event, {step: st.code, classIndex: classIndex, taskIndex: taskIndex})\"></column>\n                                    </div>\n                                  </div>\n                                  <div class=\"row -m-1 -mt-1\">\n                                    <div class=\"col-sm-12\">\n                                      <kts-multi-upload\n                                          [child]=\"true\"\n                                          [componentName]=\"componentName + '#file' + taskItem.$seq\"\n                                          [component]=\"{name: componentName + '#file' + taskItem.$seq, params: {primaryKey: 'id', fileKey: 'file', fileOptions: fileOptions}}\"\n                                          [parentCols]=\"taskTemplate.multiUpload\"\n                                          [parentItems]=\"taskItem\"\n                                          (changeItems)=\"onChangeMultiFile($event, {step: st.code, classIndex: classIndex, taskIndex: taskIndex})\"></kts-multi-upload>\n                                    </div>\n                                  </div>\n                                  <div class=\"row -m-1 -mt-1\">\n                                    <div class=\"col-sm-12\">\n                                      <column [key]=\"'form'\" [componentName]=\"componentName\" [index]=\"taskItem.$seq\" [col]=\"taskTemplate.uploadConfirm\" [val]=\"taskItem.task_u\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChangeTaskU($event, {step: st.code, classIndex: classIndex, taskIndex: taskIndex})\"></column>\n                                    </div>\n                                  </div>\n                                </ng-template>\n                                <div class=\"row -m-1 -mt-1\">\n                                  <div class=\"col-sm-12\">\n                                    <addrow\n                                        [child]=\"true\"\n                                        [componentName]=\"componentName + '#field' + taskItem.$seq\"\n                                        [component]=\"{name: componentName + '#field' + taskItem.$seq, params: {primaryKey: 'id', maxRows: '10', addable: (taskMode === 'setting'), deletable: (taskMode === 'setting')}}\"\n                                        [parentCols]=\"taskTemplate.field\"\n                                        [parentItems]=\"taskItem\"\n                                        (changeItems)=\"onChangeField($event, {step: st.code, classIndex: classIndex, taskIndex: taskIndex})\"></addrow>\n                                  </div>\n                                </div>\n                              </div>\n                            </li>\n                          </ul>\n                        </div>\n                        <button *ngIf=\"taskMode === 'setting'\" class=\"addBtn -m-0 -ml-1\" type=\"button\" (click)=\"onEvent($event, 'addTask', {step: st.code, classIndex: classIndex, taskIndex: taskIndex})\"></button>\n                      </div>\n                      <button *ngIf=\"taskMode === 'setting' && classItem.task?.length === 0\" class=\"addBtn -m-0 -ml-1\" type=\"button\" (click)=\"onEvent($event, 'addTask', {step: st.code, classIndex: classIndex, taskIndex: classItem.task.length - 1})\"></button>\n                    </div>\n                  </div>\n                </li>\n              </ul>\n            </div>\n            <button *ngIf=\"taskMode === 'setting'\" class=\"addBtn -m-0 -ml-1\" type=\"button\" (click)=\"onEvent($event, 'addClass', {step: st.code, classIndex: classIndex})\"></button>\n          </div>\n          <button *ngIf=\"taskMode === 'setting' && items[st.code]?.length === 0\" class=\"addBtn -ml-1\" type=\"button\" (click)=\"onEvent($event, 'addClass', {step: st.code, classIndex: items[st.code].length - 1})\"></button>\n          <p *ngIf=\"taskMode !== 'setting' && items[st.code]?.length === 0\" class=\"-mt-1 -ml-1\">{{ (msg | async)['au.COMPONENT.KtsGeneralTaskComponent.label.noTask'] }}</p>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"row -mt-1\">\n    <div class=\"col-sm-12\">\n      <btn [componentName]=\"componentName + '#button'\"\n           [component]=\"{\n             params: {\n               buttons: [{\n                 type: 'button',\n                 event: componentName + '#button',\n                 caption: (msg | async)['Button_save']\n               }]\n             }\n           }\"></btn>\n    </div>\n  </div>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    KtsGeneralTaskComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: KtsGeneralTaskService },
        { type: KtsTaskService },
        { type: KtsConstructionTaskService },
        { type: AlertModalService },
        { type: ValidationService }
    ]; };
    return KtsGeneralTaskComponent;
}(ContentBaseComponent));
export { KtsGeneralTaskComponent };
//# sourceMappingURL=general-task.component.js.map